import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React, { useEffect, useState } from 'react'
import { useServiceWorker } from './ServiceWorkerContext';

const UpdateAppDialog = () => {

  const { assetsUpdateReady, assetsCached, updateAssets } = useServiceWorker();

  const [ open, setOpen ] = useState(false);

  useEffect(() => {
    if (assetsUpdateReady) {
      setOpen(true);
    }
  }, [assetsUpdateReady, assetsCached, updateAssets])

  const handleClose = () => {
    setOpen(false);
    updateAssets();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">App Update Available</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You’re using an old version of the evaluation app.
          You cannot start a new evaluation or open an existing evaluation until your app has been updated.
          Click “Update” to proceed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UpdateAppDialog;